type StructuredDataNode = Record<string, unknown>

interface StructuredDataProps {
  data: StructuredDataNode | StructuredDataNode[]
}

export default function StructuredData({ data }: StructuredDataProps) {
  const nodes = Array.isArray(data) ? data : [data]

  return (
    <>
      {nodes.map((node, index) => {
        const schemaType = typeof node['@type'] === 'string' ? node['@type'] : 'structured-data'

        return (
          <script
            key={`${schemaType}-${index}`}
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(node) }}
          />
        )
      })}
    </>
  )
}
